import type { SubPedido } from '../db/tipos'
import { formatarData } from '../lib/formatos'

// ▶ A linha de datas de cada fornecedora dentro do pedido (pedido dela, 14/10):
// a data em que FECHOU e a data em que foi ENVIADA. Pedido antigo, de antes da
// 0040, nao tem as duas -- ali aparece a ultima alteracao, com esse rotulo, e
// nunca uma data de envio inventada. `!= null` e nao `!== null`: o registro em
// cache de antes da 0040 le `undefined`.
export function textoDasDatasDoSubPedido(
  sub: Pick<SubPedido, 'status' | 'atualizado_em' | 'fechado_em' | 'enviado_em'>,
): string | null {
  if (sub.status === 'rascunho') return null
  const partes: string[] = []
  if (sub.fechado_em != null) partes.push(`Fechado em ${formatarData(new Date(sub.fechado_em))}`)
  if (sub.enviado_em != null) partes.push(`Enviado em ${formatarData(new Date(sub.enviado_em))}`)
  if (partes.length === 0) return `Atualizado em ${formatarData(new Date(sub.atualizado_em))}`
  return partes.join(' · ')
}
